module.exports = __webpack_public_path__ + "static/media/9.cc30100f.jpeg";